
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jpeg-to-webp-converter",
      function () {
        return require("private-next-pages/jpeg-to-webp-converter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jpeg-to-webp-converter"])
      });
    }
  